import Api from '@/services/Api'

export default {
  get() {
    return Api().get('campaigns').then(function (response) {
      return (response)
    })
  },
  add(data) {
    return Api().post('campaigns', data).then(function (response) {
      return (response)
    })
  },
  getById(id) {
    return Api().get(`campaigns/${id}`).then(function (response) {
      return (response)
    })
  },
  partialUpdate(id, data) {
    return Api().patch(`campaigns/${id}`, data).then(function (response) {
      return (response)
    })
  }
}